/**
 * Factories
 * @module factories
 */
define(function (require, exports) {
    'use strict';

    // @ngInject
    /**
     * @param {ng.IHttpService} $http
     * @param {ng.IQService} $q
     * @param {ng.ILogService} $log
     */
    exports.metTooltipFactory = function mandatesFactory($http, $q, $log) {

        // Initiate the new mandate
        function getTooltip(category, key, placement, inline) {
            var tooltip = null;
            if (!category) {
                $log.error('Missing tooltip category for key: ' + key);
            } else if (!key) {
                $log.error('Missing tooltip key for category: ' + category);
            } else {
                var folder = window.tooltips[category];
                if (folder) {
                    tooltip = folder[key];
                }

                if (!tooltip && b$.portal.loggedInUserRole === 'admin') {
                    tooltip = {
                        key: key,
                        category: key,
                        contents: '<p>Create tooltip with name ' + key + ' in ' + category + '</p>',
                        inline: inline,
                        icon: 'warning'
                    };
                }
            }
            return tooltip;
        }
        return {
            getTooltip: getTooltip
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/metTooltip/metTooltipFactory.js